import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ImagePickerModule } from '@portal-core/forms/components/image-picker/image-picker.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { FileSizeModule } from '@portal-core/general/pipes/file-size/file-size.module';
import { TeamAvatarModule } from '@portal-core/teams/components/team-avatar/team-avatar.module';
import { TeamsSelectListModule } from '@portal-core/teams/components/teams-select-list/teams-select-list.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { LicenseSettingsFormComponent } from './license-settings-form.component';

@NgModule({
  declarations: [
    LicenseSettingsFormComponent
  ],
  imports: [
    McColorModule,
    AutocompleteInputModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FileSizeModule,
    FormsModule,
    FormControlErrorMessageModule,
    ImagePickerModule,
    LoaderModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    ReactiveFormsModule,
    TeamAvatarModule,
    TeamsSelectListModule
  ],
  exports: [
    LicenseSettingsFormComponent
  ]
})
export class LicenseSettingsFormModule { }
